import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('useGlobalStore', {
    state: () => ({
        brand: 'spoticar-access' as string,
    }),
    getters: {},
    actions: {},
});
